import { useEffect, useState } from 'react';
import { LANG_LABELS, setLang, markNudgeSeen } from '../i18n/lang';
import './LanguageNudge.css';

/**
 * First-visit language nudge (PRD-MULTILANGUAGE-IP-DETECTION §4.3, §6).
 *
 * Shown ONLY when the language was auto-detected from the visitor's IP (not a
 * stored choice) and the visitor is in India — it explains "we're showing you
 * <language>" and offers a one-tap switch to English. Non-blocking, bottom-right,
 * auto-dismisses after 8s, and never reappears once seen (`mz_lang_nudge_seen`).
 *
 * Rendered post-detection by App; `lang` is the detected code.
 */
export default function LanguageNudge({ lang, onClose }) {
  const [closing, setClosing] = useState(false);

  const dismiss = () => {
    markNudgeSeen();
    setClosing(true);
    // allow the fade-out before unmount
    setTimeout(() => onClose?.(), 200);
  };

  // Auto-dismiss after 8s.
  useEffect(() => {
    const t = setTimeout(dismiss, 8000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const switchToEnglish = () => {
    setLang('en');
    // i18next lives in lazy chunks — keep it out of the entry bundle.
    import('../i18n').then((m) => m.default.changeLanguage('en'));
    dismiss();
  };

  const native = LANG_LABELS[lang]?.native || lang;
  const english = LANG_LABELS[lang]?.english || lang;

  return (
    <div
      className={`mz-lang-nudge${closing ? ' mz-lang-nudge--closing' : ''}`}
      role="status"
      aria-live="polite"
      translate="no"
    >
      <div className="mz-lang-nudge__row">
        <span aria-hidden="true">🌐</span>
        <span>
          {native} · Showing in {english}
        </span>
      </div>
      <div className="mz-lang-nudge__actions">
        <button type="button" className="mz-lang-nudge__switch" onClick={switchToEnglish}>
          Switch to English
        </button>
        <button type="button" className="mz-lang-nudge__got" onClick={dismiss}>
          Got it ✓
        </button>
      </div>
    </div>
  );
}
